/** Thin wrapper around fetch() for /api/public/* endpoints. `api` axios
 *  instance is scoped to /api/v1 so we can't reuse it here. */
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export async function publicGet(path) {
    const r = await fetch(`${BACKEND}/api/public${path}`);
    if (!r.ok) {
        const err = new Error("public request failed");
        err.status = r.status;
        try { err.data = await r.json(); } catch { }
        throw err;
    }
    return r.json();
}

export async function publicPost(path, body) {
    const r = await fetch(`${BACKEND}/api/public${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) {
        const err = new Error(data?.detail || "public request failed");
        err.status = r.status;
        err.data = data;
        throw err;
    }
    return data;
}
